import { Component, OnInit } from '@angular/core';
import { PLPaymentResponse } from 'src/app/Shared/Model/pl-payment-response';
import { BidderRegistrationService } from 'src/app/Shared/Services/bidder-registration.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-payment-response',
  templateUrl: './payment-response.component.html',
  styleUrls: ['./payment-response.component.css']
})
export class PaymentResponseComponent implements OnInit {
  // GetResponse: PLPaymentResponse[];
  GetResponse: any = [];
  loaders: boolean = false; 
  // chckRespType: boolean = false;
  constructor(private router: Router, private MsgService: ToastrService, private BidderRegService: BidderRegistrationService) { }

  ngOnInit() {
   // debugger;

    let ResponseDecrpt = localStorage.getItem('getPymntResp');
    let decrpt = JSON.parse(window.atob(ResponseDecrpt));
    let FinalResponse = JSON.parse(decrpt);
    let GetTxnRegNo = FinalResponse.RespData.Table[0]["Txn_Regno"];

    this.BidderRegService.GetPymntResponse(GetTxnRegNo).subscribe(res => {

      if (res != null && res != undefined) {
        this.GetResponse = res.RespData[0];

        if (this.GetResponse.txn_Status == "300") {
          alert('Payment Success....!');
        } else {
          alert('Payment Failed....!');
        }

      }
      else {
        this.MsgService.warning('Record Not Found...!');
        return;
      }
    }, error => {
      this.MsgService.warning(error);
    });

  }
  ngOnDestroy() {
    localStorage.removeItem('getPymntResp');
  }
  onPrint(printDivPnl) {
    // href="payment-response.component.css"
    this.ngOnDestroy();

    let popupWinindow
    let innerContents = document.getElementById(printDivPnl).innerHTML;
    popupWinindow = window.open('', '_blank', 'width=1200,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css"/></head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.write('<style>table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:0px solid #ddd;text-align:left;padding:8px;font-size:13px;font:bold}.main-table-section{width:21cm;height:auto;margin:0;background-color:#fff;box-shadow:0 0 0.5cm rgba(0,0,0,0.5);float:left;border:1px solid #c3c1c1;padding:2px}.tbl-left{width:100%;float:left;text-align:left}.tbl-right{width:25%;float:left;text-align:left}.header{width:99%;float:left;border:4px solid #d6d2d2;margin-bottom:20px}.divclosing-section tr th:first-child{width:66%}.ledger-detail tr th:first-child{width:10%}.ledger-detail tr th:nth-child(2){width:10%}.ledger-detail tr th:nth-child(3){width:40%}.button{background-color:#4CAF50;border:none;color:white;padding:9px 32px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;margin:4px 2px;cursor:pointer;border:1px solid #4CAF50}.table-button{text-align:center;margin-top:20px}.ledger-detail label{font-weight:bold}.ledger-detail table{margin-top:10px}.mb-10{margin-bottom:20px}.mb-20{margin-bottom:10px}.ledger-detail tr td:nth-child(4){text-align:right}.ledger-detail tr td:nth-child(5){text-align:right}.ledger-detail tr td:nth-child(6){text-align:right}.divpenalty-section tr td:nth-child(n),.divclosing-section tr td:nth-child(n){text-align:right}.ledger-detail table tbody tr th{padding-bottom:25px}.sidebarreport{width:360px;height:auto;background-color:#fff;box-shadow:0 0 0.5cm rgba(0,0,0,0.5);padding:2px;float:left;margin-left:20px;border:1px solid #c3c1c1}.pannal-header{display:none;background:#7b0515;padding:8px;color:#fff;font-weight:bold;text-align:center;margin-bottom:8px}.headerhidden{display:none !important}@media print{body,page{margin:0;box-shadow:0}}.printfooter{font-weight: bold}.newheader{background-color: #7b0515;float: left;width: 100%}.newheader a img{margin-top: -20px;margin-left: 10px}.navbar-brand{display: inline-block;padding-top: .3125rem;padding-bottom: .3125rem;margin-right: 1rem;font-size: 1.25rem;line-height: inherit;white-space: nowrap}.logoprint{float: left;margin: 4px 6px}.logoprinttext{float: left;padding-top: 18px}.success{width:100%;}.faild{width:100%;}</style>');
    popupWinindow.document.close();
  }

}
